routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.serviceOrders', {
      url: __env.routes.serviceOrders,
      template: `<service-orders sh-ctrl="shCtrl"></service-orders>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/payments-advances/service-orders/service-orders.config.js
 **/